import * as React from "react";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope, faUserAlt, faMapMarkerAlt, faExternalLinkSquareAlt, faAddressCard } from "@fortawesome/free-solid-svg-icons";

import { SimpleCustomer, ExtractFriendlyName } from "src/model/Customer";

export const CustomerLink = ({
    customer,
    className,
    targetBlank,
    showAsButton,
    style,
    includeAddress,
    includePhone,
    includeEmail,
    formOfIdentification,
    identificationNumber,
    icons,
    children,
    tab
}: {
    customer: SimpleCustomer | null;
    className?: string;
    targetBlank?: boolean;
    showAsButton?: boolean;
    style?: { [cssProp: string]: string };
    icons?: boolean;
    includeAddress?: boolean;
    includePhone?: boolean;
    includeEmail?: boolean;
    formOfIdentification?: boolean;
    identificationNumber?: boolean;
    children?: React.ReactNode | string;
    tab?: string;
}) => {
    if (!customer) {
        return <div />;
    }
    return (
        <Link
            to={`/customer/${customer.id}/${tab ? tab : `overview`}`}
            className={`${showAsButton ? "btn btn-info btn-sm" : ""} ${className} d-inline-block`}
            target={targetBlank ? "_blank" : ""}
            style={style}
        >
            <div>
                {icons && <FontAwesomeIcon icon={faUserAlt} className="mr-2" />}
                {ExtractFriendlyName(customer)}
                {children && <span> - {children}</span>}
                {targetBlank && <FontAwesomeIcon icon={faExternalLinkSquareAlt} className="ml-2 fa-sm" />}
            </div>
            {includeAddress && customer.address && customer.address.address && (
                <div>
                    {icons && <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-2" />}
                    {customer.address.address && <span>{customer.address.address}, </span>}
                    {customer.address.city && <span> {customer.address.city}, </span>}
                    {customer.address.province && <span> {customer.address.province.name}</span>}
                    {customer.address.postalCode && <span> {customer.address.postalCode}</span>}
                    {customer.address.country && <span> {customer.address.country.name}</span>}
                </div>
            )}
            {includePhone && customer.primaryPhone && (
                <div>
                    {icons && <FontAwesomeIcon icon={faPhone} className="mr-2" />} {customer.primaryPhone}
                </div>
            )}
            {includeEmail && customer.email && (
                <div>
                    {icons && <FontAwesomeIcon icon={faEnvelope} className="mr-2" />} {customer.email}
                </div>
            )}
            {formOfIdentification && customer.identification && customer.identification.typeOfIdentification && (
                <div>
                    {icons && <FontAwesomeIcon icon={faAddressCard} className="mr-2" />}
                    {customer.identification.typeOfIdentification.name}
                    {identificationNumber && customer.identification && ` - ${customer.identification.identificationNumber}`}
                </div>
            )}
        </Link>
    );
};



// WEBPACK FOOTER //
// ./src/components/common/CustomerLink.tsx